import DynamicFieldListDetails from './DynamicFieldListDetails';
import DynamicFieldLists from './DynamicFieldLists';

export {
    DynamicFieldListDetails,
    DynamicFieldLists
};


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/DynamicFieldLists/index.tsx